<template>
  <div data-test="order-secure-paper" class="order-secure-paper">
    <section data-test="order-secure-paper-heading">
      <h1 class="mds-headline--medium">
        {{ $t("orderSecurePaper.title") }}
      </h1>
      <p class="mds-body--small mt-2">
        {{ $t("orderSecurePaper.subheading") }}
      </p>
    </section>
    <div
      v-if="hasSignedBLAgreement && !webBlAgreementError && !addressError && !submitError && !loading"
      data-test="order-secure-paper-form"
    >
      <section data-test="order-secure-paper-container">
        <div class="mt-2">
          <mc-notification v-if="caseNumber" appearance="success" icon="check-circle" data-test="success">
            {{ $t("orderSecurePaper.thanks") }}<br />
            <span v-html="$t('orderSecurePaper.confirmation', { caseNumber })"></span>
          </mc-notification>
        </div>
        <div class="order-secure-paper__reams mt-2">
          <mc-select
            id="numberOfReams"
            data-test="order-secure-paper-reams"
            :label="$t('orderSecurePaper.numberOfReams')"
            optionswidth="trigger"
            :value="reamValue"
            @optionselected="handleReamInput"
          >
            <mc-option v-for="ream in reamOptions" :key="ream.value" :value="ream.value" :label="ream.label" />
          </mc-select>
          <span>({{ $t("orderSecurePaper.pagesInAReam") }})</span>
        </div>

        <div data-test="order-secure-paper-address" class="order-secure-paper__address mb-5">
          <mc-textarea
            :label="$t('orderSecurePaper.deliveryAddress')"
            rows="5"
            :maxLength="250"
            :value="addressDetails"
            @input="addressDetails = $event.target.value"
          />
        </div>
        <div data-test="order-secure-paper-comments" class="order-secure-paper__comments">
          <p class="mds-text--medium-bold mb-5">{{ $t("orderSecurePaper.commentText") }}</p>
          <mc-textarea
            :label="$t('orderSecurePaper.comments')"
            rows="5"
            :maxLength="250"
            @input="handleCommentsInput"
          />
        </div>
        <div data-test="order-secure-paper-actions">
          <mc-button :label="buttonText()" data-test="order-secure-paper-submit" @click="handleSubmit" />
        </div>
      </section>
    </div>
    <div v-else-if="(webBlAgreementError || addressError || submitError) && !loading" class="mt-2">
      <mc-notification appearance="error" icon="exclamation-circle" data-test="error">
        {{ $t("orderSecurePaper.technicalError") }}
      </mc-notification>
    </div>
    <div v-else-if="!hasSignedBLAgreement && !loading" data-test="no-web-bl-agreement" class="mt-2">
      <mc-notification appearance="info" icon="info-circle">
        {{ $t("orderSecurePaper.noWebBlAgreement", { customer: addressDetails.tradingName, brandName }) }}
      </mc-notification>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapWritableState } from "pinia";
import { orderSecurePaper } from "@/store/orderSecurePaper";
import { documents } from "@/store/documents";
import { getBrandFromHostname } from "@maersk-global/shared-js";

export default {
  name: "OrderSecurePaper",
  data() {
    return {
      reamValue: 1,
      comments: "",
      submitted: false,
      brandName: getBrandFromHostname(window.location)?.commercialName,
      reamOptions: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" }
      ]
    };
  },
  computed: {
    ...mapState(orderSecurePaper, ["submitError", "caseNumber", "addressError", "loading"]),
    ...mapState(documents, ["hasSignedBLAgreement", "webBlAgreementError"]),
    ...mapWritableState(orderSecurePaper, ["addressDetails"])
  },
  async mounted() {
    await this.getPermissions();
    await this.getAddressDetails();
  },
  methods: {
    ...mapActions(orderSecurePaper, ["getAddressDetails", "requestOrderSecurePaper"]),
    ...mapActions(documents, ["getPermissions"]),
    handleCommentsInput($event) {
      this.comments = $event.target.value;
    },
    handleReamInput($event) {
      this.reamValue = $event.target.value;
    },
    buttonText() {
      return this.submitted
        ? this.caseNumber
          ? this.$t("orderSecurePaper.submitted")
          : this.$t("orderSecurePaper.processing")
        : this.$t("orderSecurePaper.submit");
    },
    async handleSubmit() {
      if (this.submitted) {
        return;
      }
      this.submitted = true;
      await this.requestOrderSecurePaper(this.reamValue, this.comments);
      this.$sendGAEvent({
        event: "BLEvent",
        category: "BL Paper",
        action: "Submit",
        label: {
          reamCount: this.reamValue,
          paperCount: this.reamValue * 500
        }
      });
    }
  }
};
</script>
